import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const storeMaterialList = (data) => {
	return {
		type: Types.STORE_MATERIAL_LIST,
		payload: data
	};
};

export const fetchMaterialList =
	(params = 'info.nitex.app.materials.MaterialComposition') =>
	async (dispatch) => {
		await ApiClient.GET('getEnums', params).then((response) => {
			dispatch(storeMaterialList(response.data));
		});
	};
